export {protoExtend}

function protoExtend(obj,extension){
  function o(extension){
    Object.assign(this,extension)
  };
  o.prototype = obj;
  return new o(extension);
}